'use strict';

exports.__esModule = true;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _compact2 = require('lodash/compact');

var _compact3 = _interopRequireDefault(_compact2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _style = require('../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

var _pbd = require('../../src/assets/pbd.svg');

var _pbd2 = _interopRequireDefault(_pbd);

var _avatarPractice = require('../../src/assets/avatarPractice.png');

var _avatarPractice2 = _interopRequireDefault(_avatarPractice);

var _headerTabs = require('header-tabs');

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _headerActions = require('../actions/header-actions');

var _widgetActions = require('../actions/widget-actions');

var _carouselActions = require('../actions/carousel-actions');

var _practiceReviewsContainer = require('./practice-reviews-container');

var _specialistReviewsContainer = require('./specialist-reviews-container');

var _constants = require('../utils/constants');

var _reactIntl = require('react-intl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = typeof navigator !== 'undefined' && navigator.languages || ['en'],
    locale = _ref[0];

var _locale$split = locale.split('-'),
    localeBase = _locale$split[0];

var lang = require('react-intl/locale-data/' + localeBase);
var messages = void 0;

try {
	messages = require('../../src/lang/' + localeBase + '.json');
} catch (error) {
	messages = require('../../src/lang/en.json');
}

(0, _reactIntl.addLocaleData)(lang);

var babelPluginFlowReactPropTypes_proptype_WidgetState = require('../reducers/widget-reducers').babelPluginFlowReactPropTypes_proptype_WidgetState || require('react').PropTypes.any;

var _ref2 = _react2.default.createElement(
	'a',
	{
		href: 'https://www.doctify.com/uk/',
		target: '_blank',
		rel: 'nofollow noopener'
	},
	_react2.default.createElement('img', { src: _pbd2.default })
);

var ProfileReviewsWidget = function ProfileReviewsWidget(props) {
	if (!props.widget || !props.header || !props.carousel) {
		throw new Error('Missing one reducer!');
	}
	var isPracticeSelected = props.widget.profileType === _constants.PRACTICE_PROFILE_TYPE;
	var isSpecialistSelected = props.widget.profileType === _constants.SPECIALIST_PROFILE_TYPE;

	var tabs = (0, _compact3.default)([props.widget.practiceReviews && props.widget.practiceReviews.length && isPracticeSelected && _constants.PRACTICE_TAB, props.widget.specialistsReviews && props.widget.specialistsReviewsCount && isPracticeSelected && _constants.SPECIALISTS_REVIEWS_TAB, props.widget.specialistsPeerRecommendations && props.widget.specialistsPeerRecommendationsCount && isPracticeSelected && _constants.SPECIALISTS_RECOMMENDATIONS_TAB, props.widget.specialistReviews && props.widget.specialistReviews.length && isSpecialistSelected && _constants.SPECIALIST_REVIEWS_TAB, props.widget.specialistRecommendations && props.widget.specialistRecommendations.length && isSpecialistSelected && _constants.SPECIALIST_RECOMMENDATIONS_TAB]);

	return _react2.default.createElement(
		_reactIntl.IntlProvider,
		{ locale: localeBase, messages: messages },
		_react2.default.createElement(
			'div',
			{ className: _style2.default.pageContainer },
			_react2.default.createElement('div', { className: _style2.default.headerCover, style: props.widget.practice && props.widget.profileType === _constants.PRACTICE_PROFILE_TYPE && (!props.widget.disableBanner || null) && {
					backgroundImage: 'url(' + props.widget.practice.cover + ')'
				} }),
			_react2.default.createElement(
				'div',
				{ className: (!props.widget || !props.widget.layoutType || props.widget.layoutType.toLowerCase() === 'page') && 'container', id: _style2.default.practiceReviewWidget },
				!props.widget.disableProfileImage && _react2.default.createElement(
					'div',
					{
						className: _style2.default.widgetHeader + ' ' + ((props.widget.profileType === _constants.SPECIALIST_PROFILE_TYPE || props.widget.disableBanner) && _style2.default.noBanner)
					},
					_react2.default.createElement(
						'div',
						{ className: _style2.default.featuredImageContainer },
						props.widget.practice && props.widget.profileType === _constants.PRACTICE_PROFILE_TYPE && _react2.default.createElement('img', { className: _style2.default.featuredImage, src: props.widget.practice.featuredImage || _avatarPractice2.default, style: !props.widget.practice.featuredImage && { backgroundColor: '#7da2b4' } || null }),
						props.widget.specialist && props.widget.profileType === _constants.SPECIALIST_PROFILE_TYPE && props.widget.specialist.profileImage && _react2.default.createElement('img', { className: _style2.default.featuredImage, src: props.widget.specialist.profileImage, style: { backgroundColor: 'white' } })
					)
				),
				_react2.default.createElement(
					'div',
					{ className: _style2.default.mainContainer + ' ' + (!props.widget || !props.widget.layoutType || props.widget.layoutType.toLowerCase() === 'page' ? _style2.default.pageLayout : '') },
					props.widget && !props.widget.disableTabs && _react2.default.createElement(_headerTabs.HeaderTabs, {
						className: _style2.default.headerTabs + ' ' + ((props.widget.profileType === _constants.SPECIALIST_PROFILE_TYPE || props.widget.disableBanner) && _style2.default.noBanner) + ' ' + (props.widget.disableProfileImage && _style2.default.noProfileImage),
						tabs: tabs,
						onTabSelected: function onTabSelected(tab) {
							props.carouselActions.setFilter();
							props.carouselActions.selectSpecialist({ id: 'all', name: 'All' });
							props.carouselActions.updateOffset({ specialistsReviewsOffset: 0, specialistsRecommendationsOffset: 0 });
							props.carouselActions.updateOffset({ specialistReviewsOffset: 0, specialistRecommendationsOffset: 0 });
							if (tab === _constants.SPECIALISTS_REVIEWS_TAB) {
								props.widgetActions.getSpecialistsReviews(props.location && props.location.query && props.location.query.profileId, { offset: 0, limit: 4, min_rating: props.widget.minReviewRating });
							}
							if (tab === _constants.SPECIALISTS_RECOMMENDATIONS_TAB) {
								props.widgetActions.getSpecialistsPeerRecommendations(props.location && props.location.query && props.location.query.profileId, { offset: 0, limit: 4 });
							}
							if (tab === _constants.SPECIALIST_REVIEWS_TAB) {
								props.widgetActions.getSpecialistReviews(props.widget.specialist && props.widget.specialist.id, _constants.SPECIALIST_PROFILE_TYPE, { offset: 0, limit: 4, min_rating: props.widget.minReviewRating });
							}
							if (tab === _constants.SPECIALIST_RECOMMENDATIONS_TAB) {
								props.widgetActions.getSpecialistPeerRecommendations(props.widget.specialist && props.widget.specialist.id, _constants.SPECIALIST_PROFILE_TYPE, { offset: 0, limit: 4 });
							}
							props.headerActions.onTabSelected(tab);
						},
						activeTab: props.header && tabs.includes(props.header.selectedTab) && props.header.selectedTab || tabs[0]
					}),
					isPracticeSelected && !!tabs.length && _react2.default.createElement(_practiceReviewsContainer.PracticeReviewsContainer, (0, _extends3.default)({}, props, {
						tabs: tabs
					})),
					isSpecialistSelected && !!tabs.length && _react2.default.createElement(_specialistReviewsContainer.SpecialistReviewsContainer, (0, _extends3.default)({}, props, {
						tabs: tabs
					})),
					!!!tabs.length && _react2.default.createElement(
						'div',
						{ className: _style2.default.noContent },
						'This profile has no content to display.'
					),
					_react2.default.createElement(
						'div',
						{ className: _style2.default.doctifyLogo },
						_ref2
					)
				)
			)
		)
	);
};

ProfileReviewsWidget.propTypes = {
	widget: babelPluginFlowReactPropTypes_proptype_WidgetState,
	carousel: require('react').PropTypes.shape({
		selectedSpecialistId: require('react').PropTypes.any
	}).isRequired,
	header: require('react').PropTypes.shape({
		selectedTab: require('react').PropTypes.any.isRequired
	}).isRequired
};
ProfileReviewsWidget.displayName = 'ProfileReviewsWidget';

ProfileReviewsWidget.defaultProps = {};

var mapStateToProps = function mapStateToProps(state) {
	return {
		global: state.global,
		header: state.profileReviewsWidget.header,
		widget: state.profileReviewsWidget.widget,
		carousel: state.profileReviewsWidget.carousel
	};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	return {
		headerActions: (0, _redux.bindActionCreators)(_headerActions.headerActions, dispatch),
		carouselActions: (0, _redux.bindActionCreators)(_carouselActions.carouselActions, dispatch),
		widgetActions: (0, _redux.bindActionCreators)(_widgetActions.widgetActions, dispatch)
	};
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ProfileReviewsWidget);
